import { AppstoreOutlined, UnorderedListOutlined } from '@ant-design/icons';
import React, {useEffect, useState} from "react";
import {Checkbox, Input, Radio, Select, Space} from "antd";
import type { CheckboxOptionType } from "antd";
type CheckboxValueType = CheckboxOptionType['value'];
import {getTagForChangeState, getTagForRuntimeStates} from "../../Common/Tags";
import {ExtendedDataProvider, SelectItem} from "../../../types";
import {useDataProvider} from "react-admin";
const { Search } = Input;
const { Option } = Select;


const ServiceItemFilterPanel = ({filterValues, setFilters, viewMode, setViewMode}: {filterValues: any, setFilters: Function, viewMode?: "grid"|"list", setViewMode?: (mode: "grid"|"list") => void}) => {
    const dataProvider: ExtendedDataProvider = useDataProvider();

    const [applications, setApplications] = useState<SelectItem[] | null>(null);
    const [services, setServices] = useState<SelectItem[] | null>(null);

    // initial filter param from url
    const [initialApplication, setInitialApplication] = useState<string|null>(filterValues.application_id)

    const onAppSelect = (value: string) => setFilters({ ...filterValues, application_id: [value] }, {});
    const onServiceSelect = (value: string) => setFilters({ ...filterValues, service_id: [value] }, {});
    const onSearch = (value: string) => setFilters({ ...filterValues, name: value }, {});

    const applicationsResource = "applications";
    useEffect(() => {
        if(applicationsResource){
            dataProvider.getFilterOptions(
                applicationsResource,
                {
                    pagination: { page: 1, perPage: 20 },
                    sort: { field: 'name', order: 'asc' },
                    filter: {}
                })
                .then(({ data }) => {
                    const appFilter: any[] = []
                    if (data) {
                        for (let item of data) {
                            appFilter.push({ 'text': item.name, 'value': item.id })
                            if(item.id.toString()===initialApplication)
                                setInitialApplication(item.name)
                        }
                        setApplications(appFilter);
                    }
                })
                .catch(error => {console.log(error)})
        }
    }, [applicationsResource])

    const servicesResource = "consumer_services";
    useEffect(() => {
        if(servicesResource){
            dataProvider.getFilterOptions(
                servicesResource,
                {
                    pagination: { page: 1, perPage: 20 },
                    sort: { field: 'name', order: 'asc' },
                    filter: {}
                })
                .then(({ data }) => {
                    const serviceFilter: any[] = []
                    if (data) {
                        for (let item of data) {
                            serviceFilter.push({ 'text': item.name, 'value': item.id })
                        }
                        setServices(serviceFilter);
                    }
                })
                .catch(error => {console.log(error)})
        }
    }, [servicesResource])

    return (
        <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
            {viewMode && setViewMode && (
                <div>
                    <label className="filter-label">View</label>
                    <Radio.Group
                        onChange={(e) => setViewMode(e.target.value)}
                        buttonStyle="solid"
                        value={viewMode}
                        style={{ marginTop: 4 }}
                    >
                        <Radio.Button value="grid"><AppstoreOutlined /></Radio.Button>
                        <Radio.Button value="list"><UnorderedListOutlined /></Radio.Button>
                    </Radio.Group>
                </div>
            )}

            <div>
                <label className="filter-label">Name</label>
                <Search
                    className='item-search'
                    style={{ borderRadius: '8px', overflow: 'hidden' }}
                    allowClear
                    placeholder="Search by name"
                    onSearch={onSearch}
                    enterButton
                />
            </div>

            <div>
                <label className="filter-label">Application</label>
                {applications && (
                    <Select
                        data-cy="application-selector"
                        defaultValue={initialApplication}
                        placeholder="Select Application"
                        style={{ width: '100%', marginTop: 4 }}
                        className="filter-select"
                        onChange={onAppSelect}
                    >
                        <Option key={0} value="">All Apps</Option>
                        {applications.map(app => <Option key={app.value} value={app.value}>{app.text}</Option>)}
                    </Select>
                )}
            </div>

            <div>
                <label className="filter-label">Service</label>
                <Select
                    data-cy="service-selector"
                    value={services && filterValues.service_id}
                    placeholder="Select Service"
                    style={{ width: '100%', marginTop: 4 }}
                    className="filter-select"
                    onChange={onServiceSelect}
                >
                    <Option key={0} value="">All Services</Option>
                    {services?.map(service => <Option key={service.value} value={service.value}>{service.text}</Option>)}
                </Select>
            </div>

            <div>
                <label className="filter-label">Change State</label>
                <Checkbox.Group
                    value={filterValues?.change_state?.split(',')}
                    onChange={(checked: Array<CheckboxValueType>) => setFilters({ ...filterValues, 'change_state': checked.join() }, {})}
                    style={{ marginTop: 4 }}
                >
                    {['ALL_CHANGES_COMPLETED', 'CHANGES_APPROVED', 'CHANGES_PENDING', 'CHANGES_REJECTED', 'CHANGES_ERRORED'].map(tag => (
                        <div key={tag} style={{ paddingBottom: 4 }}>
                            <Checkbox value={tag}>{getTagForChangeState(tag)}</Checkbox>
                        </div>
                    ))}
                </Checkbox.Group>
            </div>

            <div>
                <label className="filter-label">Runtime State</label>
                <Checkbox.Group
                    data-cy="runtime-state-checkbox-group"
                    value={filterValues?.runtime_state?.split(',')}
                    onChange={(checked: Array<CheckboxValueType>) => setFilters({ ...filterValues, 'runtime_state': checked.join() }, {})}
                    style={{ marginTop: 4 }}
                >
                    {['IN_SERVICE', 'REQUESTED', 'DECOMMISSIONED'].map(tag => (
                        <div key={tag} style={{ paddingBottom: 4 }}>
                            <Checkbox value={tag}>{getTagForRuntimeStates(tag)}</Checkbox>
                        </div>
                    ))}
                </Checkbox.Group>
            </div>
        </Space>
    )
}

export default ServiceItemFilterPanel;
